export interface Testimonial {
  name: string
  role: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Jessica Warren, M.S., CCC-SLP',
    role: '34 · School SLP — Columbus, OH',
    quote:
      'I carry a caseload of 58 students and used to spend my entire Sunday building sessions. Now I open the Session Builder, pick a 30-minute plan, print the visuals, and I am done in ten minutes. My IEP goals come straight from the Goal Bank and my documentation is finally consistent.',
  },
  {
    name: 'Marcus Ellison, M.A., CCC-SLP',
    role: '41 · Private Practice Owner — Austin, TX',
    quote:
      'The value here is the organization. Everything is grouped by communication area, so I can move from an articulation kid at 9am to an adult aphasia client at 11am without scrambling. The SOAP templates alone cut my note-writing time in half.',
  },
  {
    name: 'Priya Raghunathan, MS, CCC-SLP',
    role: '29 · Early Intervention — Sacramento, CA',
    quote:
      'The Home Practice Toolkit changed my parent sessions. I send families a printable program at the end of every visit and carryover has genuinely improved. Parents tell me they finally know what to do between appointments.',
  },
  {
    name: 'Danielle Foster, M.S., CCC-SLP',
    role: '47 · Rehabilitation Hospital — Tampa, FL',
    quote:
      'I was skeptical that adult clinical work would be covered, but the cognitive and functional communication material is solid and easy to adapt. I use the progress trackers for every patient and my reports are much cleaner now.',
  },
  {
    name: 'Rebecca Lindqvist, SLP',
    role: '36 · Pediatric Clinic — Denver, CO',
    quote:
      'The Therapy Games Collection saved my late-afternoon sessions. Kids stay engaged, I still hit the target sounds, and I stopped buying random materials online every month. Best $27 I have spent on my practice.',
  },
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this a physical product or a digital download?',
    answer:
      'This is a 100% digital product delivered instantly in high-quality PDF format. You can access it immediately from your computer, tablet, or smartphone.',
  },
  {
    question: 'Is this designed for professional Speech Therapists?',
    answer:
      'Yes. This system was created specifically for Speech Therapists and Speech-Language Pathologists who already have professional training and want ready-to-use clinical resources. It is not a course on how to become a Speech Therapist.',
  },
  {
    question: 'Can I use it with different age groups?',
    answer:
      "Absolutely. The system includes professional resources that can be adapted for children, adolescents, adults, schools, private practice, rehabilitation settings, and clinical environments depending on your patients' needs.",
  },
  {
    question: 'Can I adapt the material to my own therapy approach?',
    answer:
      'Yes. Every activity, session, worksheet, treatment plan, documentation template, and printable resource can easily be adapted to your clinical style, patient goals, and intervention methods.',
  },
  {
    question: 'Is everything ready to use?',
    answer:
      'Yes. Every resource has been designed to reduce preparation time and can be printed and implemented immediately in your daily clinical practice.',
  },
  {
    question: 'How quickly will I notice the benefits?',
    answer:
      'Most therapists begin saving preparation time and feeling more organized during the very first week because every resource is already structured and ready to use.',
  },
  {
    question: 'When will I receive access?',
    answer:
      'Immediately after completing your purchase. The complete system will be delivered digitally by email within minutes.',
  },
  {
    question: 'Do the printable resources work with school and clinic caseloads?',
    answer:
      'Yes. Worksheets, flashcards, cue cards, visual supports, and communication boards are print-ready in standard formats, so you can reuse them across an entire caseload in schools, clinics, hospitals, and private practice.',
  },
  {
    question: 'Does it include documentation I can use for reports and insurance notes?',
    answer:
      'The system includes progress notes, SOAP templates, treatment reports, goal trackers, parent communication forms, and school reports that you can adapt to the documentation standards required in your setting.',
  },
  {
    question: 'What if the system is not right for me?',
    answer:
      "You are protected by a 7-Day Money-Back Guarantee. Review every module, use the sessions, print the resources, and if you're not completely satisfied, contact us within the first 7 days for a 100% refund. No questions asked.",
  },
]
